import { useSearchParams } from 'react-router-dom';
import { EventView as LegacyEventView } from '../views/EventView';
import { EventView } from './EventView';

export const VIEW_PARAM = 'view';
export const LEGACY_VIEW_VALUE = 'legacy';

export function EventRoute() {
    const [searchParams] = useSearchParams();
    return searchParams.get(VIEW_PARAM) === LEGACY_VIEW_VALUE ? (
        <LegacyEventView />
    ) : (
        <EventView />
    );
}
